
import { Panel } from "primereact/panel";
import { useEffect, useRef, useState } from "react";
import { TextField } from "../../../components/TextField";
import Highcharts from 'highcharts';
import PieChart from "highcharts-react-official";
import Chart from "highcharts-react-official";
import { DeferredContent } from "primereact/deferredcontent";
 
 (function (H : any) {
    H.seriesTypes.pie.prototype.animate = function (init:any) {
        const series = this,
            chart = series.chart,
            points = series.points,
            {
                animation
            } = series.options,
            {
                startAngleRad
            } = series;

        function fanAnimate(point:any, startAngleRad:any) {
            if(point){
              const graphic = point.graphic,
                  args = point.shapeArgs;

              if (graphic && args) {

                  graphic
                      // Set inital animation values
                      .attr({
                          start: startAngleRad,
                          end: startAngleRad,
                          opacity: 1
                      })
                      // Animate to the final position
                      .animate({
                          start: args.start,
                          end: args.end
                      }, {
                          duration: animation.duration / points.length
                      }, function () {
                          // On complete, start animating the next point
                          if (points[point.index + 1]) {
                              fanAnimate(points[point.index + 1], args.end);
                          }
                          // On the last point, fade in the data labels, then
                          // apply the inner size
                          if (point.index === series.points.length - 1) {
                            if(series.dataLabelsGroup){
                              series.dataLabelsGroup.animate({
                                  opacity: 1
                              },
                              void 0,
                              function () {
                                  points.forEach((point:any) => {
                                      point.opacity = 1;
                                  });
                                  series.update({
                                      enableMouseTracking: true
                                  }, false);
                                  chart.update({
                                      plotOptions: {
                                          pie: {
                                              innerSize: '40%',
                                              borderRadius: 8
                                          }
                                      }
                                  });
                              });
                            }
                          }
                      });
              }
            }
        }

        if (init) {
            // Hide points on init
            points.forEach((point:any) => {
                point.opacity = 0;
            });
        } else {
            fanAnimate(points[0], startAngleRad);
        }
    };
}(Highcharts));
 
export const BacenScoreSCRSintetico = (data: any) => {
  const cadastral = data?.return.localizacao.cpf_cnpj.dados_cadastrais ?? null;
  const report = data?.return.sintetico ?? null;
  const divRef = useRef<any>(null);
  const [loadChart, setLoadChart] = useState<boolean>(false) 
  const getValue = (value?: string): string => value || "Não informado";

  const dataSerie: any[] = [];
  if(report.percentualModalidade){
    report.percentualModalidade.forEach((item:any) => {
      dataSerie.push({name:item.nome, y: Number(item.totalPercent.replace('%',''))})
    })
  }

  const dataSerieBar: any[] = [];
  if(report.listcarteiraAtiva_A){
    report.listcarteiraAtiva_A.forEach((item:any) => {
      const seriesBar: any[] = [];
      seriesBar.push(item.vencimento)
      seriesBar.push(Number(item.percentual.replace('%','')))
      dataSerieBar.push(seriesBar)
    })
  }

  const optionsBar = {
    chart: {
      type: "column"
    },
    title: {
      text: 'Carteira Ativa a Vencer'
    },
    xAxis: {
      type: 'category',
      labels: {
          autoRotation: [-45, -90],
          style: {
              fontSize: '10px',
              fontFamily: 'Verdana, sans-serif'
          }
      }
    },
    yAxis: {
      title: {text:'Percentual'},
      allowDecimals: false,
      labels: {               
        formatter: function (e:any):string  {
            return '' + e.value;
        }
      }
    
    },
    tooltip: {
        pointFormat: '<b>{point.y:.2f}%</b>'
    },
    credits: {
      enabled: false
    },
    legend: {
        enabled: false
    },
    series: [{
        name: '',
        colors: [
            '#183462'
        ],
        colorByPoint: true,
        groupPadding: 0,
        data:dataSerieBar,
        dataLabels: {
            enabled: true,
            color: '#FFFFFF',
            inside: true,
           
            format: '{point.y:.2f}%', // one decimal
            y: 10, // 10 pixels down from the top
            style: {
                fontSize: '10px',
                fontFamily: 'Verdana, sans-serif'
            }
        }
      }]
  };


  const options = {
    chart: {
      type: "pie"
    },
    title: {
      text: 'Carteira Ativa Total'
    },
    accessibility: {
        point: {
            valueSuffix: '%'
        }
    },
    plotOptions: {
        pie: {
            allowPointSelect: true,
            borderWidth: 2,
            cursor: 'pointer',
            dataLabels: {
                enabled: true,
                format: '<b>{point.name}</b><br>{point.percentage:.2f}%',
                distance: 20
            }
        }
    },
    tooltip: {
        headerFormat: '',
        pointFormat:
            '<span style="color:{point.color}">\u25cf</span> ' +
            '{point.name}: <b>{point.percentage:.2f}%</b>'
    },
    credits: {
      enabled: false
    },
    series:  [{
        // Disable mouse tracking on load, enable after custom animation
        enableMouseTracking: false,
        animation: {
            duration: 2000
        },
        colorByPoint: true,
        data: dataSerie
    }]
  };

  const loadingChart = () => {

    if (divRef.current) {
      
      const rect = divRef.current.getBoundingClientRect();
      const isVisible = (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );

      if (isVisible) {
        setLoadChart(true)
      } 
    }

  }

  useEffect(() => {
    const handleScroll = () => {
      loadingChart()
    };
    window.addEventListener('scroll', handleScroll);
    loadingChart()
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
 
  return (
    <div>
      <Panel header="Dado Comportamental de Pagamento Sintético">
        <Panel header="Identificação">
          <section style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
            <div>
              <TextField
                label="Documento"
                value={getValue(cadastral?.documento)}
              />
              <TextField
                label="Data Nascimento"
                value={getValue(cadastral?.data_nascimento)}
              />
              <TextField
                label="Nome Mãe"
                value={getValue(cadastral?.nome_mae)}
              />
            </div>
            <div>
              <TextField
                label="Nome"
                value={getValue(cadastral?.nome)}
              />
              <TextField
                label="Idade"
                value={getValue(
                  cadastral?.idade
                )}
              />
              <TextField
                label="Sexo"
                value={getValue(cadastral?.sexo)}
              />
            </div>
          </section>
        </Panel>
        <br />
        <Panel header="Resumo">
          <section style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
            <div>
              <TextField
                label="Valor Estimado Inicial"
                value={getValue(report?.valorEstimadoInicial)}
              />
              <TextField
                label="Instituições Financeiras"
                value={getValue(report?.quantidadeDeInstituicoes)}
              />
              <TextField
                label="Data de início de relacionamento"
                value={getValue(report?.dataInicioRelacionamento)}
              />
              <TextField
                label="Último Pagamento Realizado"
                value={getValue(report?.dataBaseFinal)}
              />
            </div>
            <div>
              <TextField
                label="Valor Estimado Final"
                value={getValue(report?.valorEstimadoFinal)}
              />
              <TextField
                label="Total de Operações"
                value={getValue(
                  report?.quantidadeDeOperacoes
                )}
              />
              <TextField
                label="Data Base"
                value={getValue(report?.dataBaseConsultada)}
              />
              <TextField
                label="Última Parcela a Vencer"
                value={getValue(report?.dataBaseFinalMaiorPrazo)}
              />
            </div>
          </section>
        </Panel>
 
        <br />
        <div ref={divRef}>
          <Panel header="Carteira">
            <DeferredContent>
              {loadChart && (
                <div className="srcSintetico">
                  <div style={{width: '500px'}}>
                    <PieChart highcharts={Highcharts} options={options} />
                  </div>
                  <div className="srcSintericoBar">
                    <Chart highcharts={Highcharts} options={optionsBar} />
                  </div>
                   <div className="srcSintericoBarPrint">
                    <Chart highcharts={Highcharts} options={optionsBar} />
                  </div>
                </div>
              
              )}
            </DeferredContent>
          </Panel>
        </div>
 
        <br />
 
         
      </Panel>
    </div>
  );
};